<div class="form-field">
  @if (props['label']) {
  <label [for]="id" class="form-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }
  <input [id]="id" class="form-input" [class.has-error]="formControl.touched && formControl.invalid" type="email"
    [formControl]="formControl" [formlyAttributes]="field"
    [placeholder]="props['placeholder'] || ''" [required]="props['required'] || false"
    [attr.pattern]="props['pattern'] ?? null"
    [attr.data-testid]="props['attributes']?.['data-testid'] || ('field-' + field.key)" />
  @if (props['description']) {
  <div class="form-description">{{ props['description'] }}</div>
  }
  @if (formControl.touched && formControl.errors) {
  <div class="field-error">
    @if (formControl.errors['required']) {
    <span>{{ 'field.validation.required' | translate }}</span>
    } @else if (formControl.errors['pattern']) {
    <span>{{ 'field.validation.invalidEmail' | translate }}</span>
    }
  </div>
  }
</div>